import {Modal, ModalBody} from "../../modal/Modal";
import React, { useEffect, useState } from "react";
import ExamService from "../../../services/ExamService";
import GLOBAL from "../../../global";
import { getMarkup, playAudio } from "../../../utils/Utils";

const ALERT_CONFIG = {
    warning: { icon: "fas fa-exclamation-triangle", role: "alert" },
    info: { icon: "fas fa-info-circle", role: "note" },
    danger: { icon: "fas fa-times-circle", role: "alert" },
    success: { icon: "fas fa-check-circle", role: "status" },
};

const getAlertConfig = (instruction) => {
    const alertType = typeof instruction?.AlertType === "string"
        ? instruction.AlertType.trim().toLowerCase()
        : "";
    const hasAlertMessage = typeof instruction?.AlertMessage === "string"
        && instruction.AlertMessage.trim().length > 0;

    if (!alertType || !hasAlertMessage) {
        return null;
    }

    return {
        type: ALERT_CONFIG[alertType] ? alertType : "info",
        ...(ALERT_CONFIG[alertType] || ALERT_CONFIG.info),
    };
};

const PreparationInstructionsModal = (props) => {
    const [instructions, setInstructions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [headerTitle, setHeaderTitle] = useState("");

    useEffect(() => {
      const fetchInstructions = async () => {
        try {
          const payload = {
            Tenant: GLOBAL.TENANT,
            TestId: props?.testId,
          };

          const response = await ExamService.getAssessmentInstructions(payload);
          if (response?.data) {
            const message = response?.data;

            if (message?.IsDisabledForTenant) {
              props?.onClose();
              return;
            }

            if (message?.InstructionSetList) {
              // Sort parent instructions and their children by ViewOrder
              const processedInstructions = [...message.InstructionSetList]
                .sort((a, b) => (a.ViewOrder || 0) - (b.ViewOrder || 0))
                .map((parent) => ({
                  ...parent,
                  ChildList: (parent.ChildList || []).sort(
                    (a, b) => (a.ViewOrder || 0) - (b.ViewOrder || 0),
                  ),
                }));

              setInstructions(processedInstructions);
            }

            if (message?.HeaderTitle) {
              setHeaderTitle(message.HeaderTitle);
            }
          }
        } catch (error) {
          console.error("Error fetching assessment instructions:", error);
          // Fallback to default instructions if API call fails
          setInstructions([]);
        } finally {
          setLoading(false);
        }
      };

      fetchInstructions();
    }, []);

    const handleOkClick = () => {
        playAudio('remove');
        props?.onClose();
    }

    if (loading) {
        return (
            <Modal
                isOpen={true}
                backdrop={true}
                className="preparation-instructions-modal-container">
                <div className="preparation-instructions-header-bar">
                    <span>Loading...</span>
                </div>
                <ModalBody>
                    <div className="text-center py-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        );
    }

    return (
        <Modal
            isOpen={true}
            backdrop={true}
            className="preparation-instructions-modal-container">
            
            <div className="preparation-instructions-header-bar">
                <span>{headerTitle}</span>
            </div>

            <ModalBody>
                <div className="preparation-instructions-content-wrapper">
                    <div className="preparation-instructions-scroll-area">
                        {instructions.map((instruction) => {
                            const alertConfig = getAlertConfig(instruction);

                            return (
                                <div className="preparation-instructions-section" key={instruction.Id}>
                                    {alertConfig ? (
                                        <div
                                            className={`preparation-instructions-alert preparation-instructions-alert--${alertConfig.type}`}
                                            role={alertConfig.role}
                                        >
                                            <i
                                                className={`preparation-instructions-alert-icon ${alertConfig.icon}`}
                                                aria-hidden="true"
                                            />
                                            <div className="preparation-instructions-alert-content">
                                                <div
                                                    className="preparation-instructions-alert-title"
                                                    dangerouslySetInnerHTML={getMarkup(instruction.Title || "")}
                                                />
                                                <div
                                                    className="preparation-instructions-alert-message"
                                                    dangerouslySetInnerHTML={getMarkup(instruction.AlertMessage)}
                                                />
                                            </div>
                                        </div>
                                    ) : (
                                        <div
                                            className="preparation-instructions-section-title"
                                            dangerouslySetInnerHTML={getMarkup(instruction.Title || "")}
                                        />
                                    )}
                                    {instruction.HasChildElement && instruction.ChildList && instruction.ChildList.length > 0 && (
                                        <div className="preparation-instructions-section-children">
                                            {instruction.ChildList.map((child) => (
                                                <div
                                                    className="preparation-instructions-section-item"
                                                    key={child.Id}
                                                    dangerouslySetInnerHTML={getMarkup(child.Title || "")}
                                                />
                                            ))}
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>

                    <div className="preparation-instructions-footer">
                        <button 
                            className="preparation-instructions-ok-btn"
                            onClick={handleOkClick}
                        >
                            Ok
                        </button>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    )
}

export default PreparationInstructionsModal;
